import {
  GET_VAULT_REQUEST_BY_ID_REQUESTED,
  GET_VAULT_REQUEST_BY_ID_FAILED,
  GET_VAULT_REQUEST_BY_ID_SUCCESS,
  DELETE_VAULT_REQUEST_REQUESTED,
  DELETE_VAULT_REQUEST_SUCCESS,
  DELETE_VAULT_REQUEST_FAILED,
  UPDATE_VAULT_REQUEST_FAILED,
  UPDATE_VAULT_REQUEST_REQUESTED,
  UPDATE_VAULT_REQUEST_SUCCESS,
  ADD_NEW_VAULT_REQUEST_REQUESTED,
  ADD_NEW_VAULT_REQUEST_SUCCESS,
  ADD_NEW_VAULT_REQUEST_FAILED,
  CLEAR_VAULT_REQUEST,
} from '../actions/actionTypes';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const vaultRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VAULT_REQUEST_BY_ID_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VAULT_REQUEST_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case GET_VAULT_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case DELETE_VAULT_REQUEST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case DELETE_VAULT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case DELETE_VAULT_REQUEST_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case UPDATE_VAULT_REQUEST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_VAULT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case UPDATE_VAULT_REQUEST_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case ADD_NEW_VAULT_REQUEST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_VAULT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action?.payload?.data,
      };
    case ADD_NEW_VAULT_REQUEST_FAILED:
      return {
        ...state,
        loading: false,
        error: action?.payload?.error,
      };
    case CLEAR_VAULT_REQUEST:
      return initialState;
    default:
      return state;
  }
};

export default vaultRequestReducer;
